import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import "./css/styles.css";
import "assets/styles/global.css";
import { ErrorBoundary } from "react-error-boundary";
import { SettingsProvider } from "./providers/settings-provider";
import { ThemeProvider } from "providers/theme-provider";
import { HelmetProvider } from "react-helmet-async";
import configStore from "store";
import { Provider } from "react-redux";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { theme } from "theme";

const ErrorFallback = lazy(() => import("./components/fallbackUI/Error"));
const Loader = lazy(() => import("./components/fallbackUI/Loading"));
const store = configStore();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <SettingsProvider>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider>
          <HelmetProvider>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <Router>
                <Suspense fallback={<Loader />}>
                  <Provider store={store}>
                    <App />
                  </Provider>
                </Suspense>
              </Router>
            </ErrorBoundary>
          </HelmetProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </SettingsProvider>
  </React.StrictMode>,
);

reportWebVitals();
